import { render, staticRenderFns } from "./provisional-advancement-list.vue?vue&type=template&id=2d638e3a&"
import script from "./provisional-advancement-list.vue?vue&type=script&lang=ts&"
export * from "./provisional-advancement-list.vue?vue&type=script&lang=ts&"
import style0 from "./provisional-advancement-list.vue?vue&type=style&index=0&id=2d638e3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports